<template>
  <b-card v-if="show" no-body class="reports-design-used-card">
    <b-button block variant="light" class="reports-design-used-header" v-b-toggle.reports-used-escpos>
      <AppIcon name="receipt" /> ESC/POS
    </b-button>
    <b-collapse id="reports-used-escpos" accordion="reports-used" :visible="open">
      <b-card-body>
        <pre v-if="data" class="reports-design-pre-json reports-design-json-code" v-html="formatJson(data)"></pre>
        <EmptyState v-else icon="receipt" title="Aún no se utilizó ninguna variable" description="Las variables que uses en el ticket ESC/POS van a aparecer acá." />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import AppIcon from '@/components/inc/icon/AppIcon'
import EmptyState from '@/components/inc/state/EmptyState'
import JsonHighlight from '../../helpers/jsonHighlight'

export default {
  name: 'EscposUsedAccordion',
  components: { AppIcon, EmptyState },
  props: {
    show: { type: Boolean, default: false },
    open: { type: Boolean, default: false },
    data: { type: Object, default: null },
  },
  methods: {
    formatJson(data) {
      return JsonHighlight.formatJson(data)
    },
  },
}
</script>
